import { createStyles, rem } from '@mantine/core'

type StylesParams = {
  color?: string
}

export default createStyles((theme, { color }: StylesParams) => {
  return {
    root: {},
    scoreArea: {
      '&:after': {
        content: '""',
        display: 'block',
        width: 96,
        margin: `${rem(8)} 0`,
        borderRadius: 4,
        backgroundColor: color || theme.fn.primaryColor(),
        height: 4,
        [theme.fn.smallerThan('sm')]: {
          width: 48,
        },
      },
    },
    score: {
      [theme.fn.smallerThan('sm')]: {
        fontSize: rem(22),
        lineHeight: rem(32),
        fontWeight: 600,
      },

      fontSize: rem(40),
      lineHeight: rem(48),
    },
    unit: {
      display: 'inline-block',
      marginLeft: 8,
    },
  }
})
